export const currencySymbolFor = (currencyCode) => {
  const code = String(currencyCode || '').trim().toUpperCase();
  switch (code) {
    case 'USD':
    case 'CAD':
    case 'AUD':
      return '$';
    case 'EUR':
      return '€';
    case 'GBP':
      return '£';
    case 'SAR':
      return '﷼';
    case 'AED':
      return 'د.إ';
    case 'KWD':
      return 'د.ك';
    case 'QAR':
      return 'ر.ق';
    case 'BHD':
      return 'د.ب';
    case 'JOD':
      return 'د.ا';
    case 'EGP':
      return 'E£';
    default:
      return code ? `${code} ` : '';
  }
};

export const formatMoney = (amount, currencyCode) => {
  const n = Number(amount);
  const symbol = currencySymbolFor(currencyCode);
  if (!Number.isFinite(n)) return `${symbol}0.00`;
  return `${symbol}${n.toFixed(2)}`;
};
